export default __webpack_public_path__ + "static/media/dutAf.7d271286.png";